<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'CuscoTour',

    metaInfo: { title: 'Post-Conference Cusco Tour' },

    extends: View,

    mixins: [
      LoadSections([
        'cusco-tour',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'cusco-tour',
      },
    },
  }
</script>
